import React, { useEffect, useState } from "react";
import './styles.css'
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import { useNavigate } from 'react-router-dom';
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserOperator, isLoggedInUserAdmin, isLoggedInUserBusiness, isNull, isValidEmail } from "../../../utils/Utils";
import { loginUserRequest, displaySideBarAct } from '../../../redux/user/user.action'
import { useDispatch, useSelector } from 'react-redux'
import { APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import NavBarComponent from "../../landing/nav-bar/navBar";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import PasswordInputFull from "../../../components/input/password-input-full/passwordInputFull";

const ForgotPassword = props => {
    const [isLoading, setLoading] = useState(false)
    const [email, setEmail] = useState('')
    const [accessCode, setAccessCode] = useState('')
    const [password, setPassword] = useState('')
    let navigate = useNavigate();
    const { user, isLogin, loginErrorData } = useSelector(state => state.user)
    const dispatch = useDispatch()
    const [isDisable, setIsDisable] = useState(false)

    const handleGetCodeClick = () => { }

    return (
        <>
            <>
                <NavBarComponent navigate={navigate}
                    showHome={true}
                    isWhiteBackground={true}
                    showBusinessRegistration={true} />
                <div className='sign-in-parent-container'>
                    <div className='sign-in-img-layout-container'>
                        <img src={require('../../../assets/forgot-password-banner.jpg')} className='sign-up-img-container' />
                        <img src={require('../../../assets/forgot-password-banner-tab.jpg')} className='sign-up-tab-img-container' />
                        {/* <div className="sign-up-brand-label">GOMOBITES</div> */}
                    </div>
                    <div className='sign-in-content-layout-container'>
                        <div className="sign-in-logo-container">
                            <img src={require('../../../assets/logo_togethra_icon.png')} alt='logo' className="img" />
                        </div>
                        <div className='sign-in-heading'>Forgot your <span className='sign-in-heading-label'>togethra</span> password?</div>
                        <FormFieldLabel label='Enter your registered email id' className='sign-in-sub-text-label margin-bottom-10' />
                        <CommonInputFloatFull
                            id="email"
                            placeholder="Email Address"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            type="email"
                            isDisable={isDisable} />
                        <ButtonRow>
                            <CommonButton label='Get Access Code'
                                onClick={() => handleGetCodeClick()}
                            />
                        </ButtonRow>
                    </div>
                </div>
                <ToastContainer />
                <Loader active={isLoading} text='Please wait...' />
            </>
        </>
    )
}

export default ForgotPassword